import basketAPI from '../../api/Basket'
import * as types from '../mutation-types'

// STATE
const state = {
    Basket: {
        OrderDeliveryAddress: {},
        Products: []
    },
    BasketCount: 0,
    BasketErrors: [],
    OrderAxId: '',
    GTMObject: {}
}

// GETTERS
const getters = {
    getBasket: state => state.Basket,
    getBasketCount: state => state.BasketCount,
    getOrderAxId: state => state.OrderAxId,
    getGTMObject: state => state.GTMObject
}

//ACTIONS
const actions = {
    //Get current basket
    getBasket({ commit }, params){
       return new Promise((resolve, reject) => {
           basketAPI.getBasket(basket => {
                commit(types.RECEIVE_CURRENTBASKET, basket )
                resolve(basket)
           }, params)
       })
    },
    addProductsToBasket({commit}, params){
        return new Promise((resolve, reject)=> {
            basketAPI.addProductsToBasket(result => {
                resolve(result)
            }, params)
        })
    },
    updateItemInBasket({commit}, params){
        return new Promise((resolve, reject)=> {
            basketAPI.updateItemInBasket(result => {
                resolve(result)
            }, params)
        })
    },
    removeItemFromBasket({commit}, params){
        return new Promise((resolve, reject) => {
            basketAPI.removeItemFromBasket(basket => {
                resolve(basket)
            }, params)
        })
    },
    validateBasket({commit}, params){
        return new Promise((resolve, reject)=> {
            basketAPI.validateBasket(basket => {
                resolve(basket)
            }, params)
        })
    },
    processBasket({commit}, params){
        return new Promise((resolve, reject)=> {
            basketAPI.processBasket(basket => {
                if(basket.data && basket.data.ModelState) {
                    resolve(basket)
                } else {
                    commit(types.SUCCESS_BASKET, basket)
                    resolve(basket)
                }
            }, params)
        })
    },
    switchBasket(){
        return new Promise((resolve, reject)=> {
            basketAPI.switchBasket(basket => {
                if (basket.status > 300) {
                    reject(basket);
                } else {
                    resolve(basket)
                }
            })
        })
    },
    updateBasketCount({commit}, count) {
        commit(types.UPDATE_BASKET_COUNT, count);
    }
}

//MUTATIONS
const mutations = {
    [types.RECEIVE_CURRENTBASKET] (state, response) {
        state.Basket = response.Basket;

        let count = 0;
        if (response.Basket) {response.Basket.Products.forEach((product) => {
             product.Variants.forEach((variant) => {
                count = count + variant.ProductAmount
            });
        });}
        state.BasketCount = count;
    },
    [types.SUCCESS_BASKET] (state, response) {
        state.OrderAxId = response.axId;
        state.GTMObject = response.gtmObject;
        state.BasketCount = 0;
    },
    [types.UPDATE_BASKET_COUNT] (state, count) {
        state.BasketCount = count;
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/Basket.js